module.exports = __webpack_public_path__ + "static/img/01.12bb4d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/04/01.jpg
// module id = TRDJ
// module chunks = 0